import { GameState, GROUND, PLAYER_HEIGHT, PLAYER_X } from './engine';

// Original pixel silhouette; no external sprites or Chrome game assets.
export function drawDinosaur(ctx: CanvasRenderingContext2D, x: number, y: number, stride = 0) {
  ctx.fillStyle = '#222a35';
  ctx.beginPath();
  ctx.moveTo(x, y + 18); ctx.lineTo(x + 8, y + 26); ctx.lineTo(x + 18, y + 26);
  ctx.lineTo(x + 18, y + 4); ctx.lineTo(x + 22, y); ctx.lineTo(x + 40, y);
  ctx.lineTo(x + 40, y + 16); ctx.lineTo(x + 28, y + 16); ctx.lineTo(x + 28, y + 20);
  ctx.lineTo(x + 36, y + 20); ctx.lineTo(x + 36, y + 24); ctx.lineTo(x + 28, y + 24);
  ctx.lineTo(x + 28, y + 34); ctx.lineTo(x + 22, y + 38); ctx.lineTo(x + 10, y + 38);
  ctx.lineTo(x, y + 27); ctx.closePath(); ctx.fill();
  ctx.fillRect(x + 11, y + 36, 5, stride === 1 ? 4 : 8);
  ctx.fillRect(x + 21, y + 34, 5, stride === 2 ? 5 : 10);
  ctx.fillStyle = '#fff'; ctx.fillRect(x + 30, y + 5, 4, 4);
}
export function drawScene(ctx: CanvasRenderingContext2D, game: GameState) {
  const w = game.width;
  ctx.clearRect(0, 0, w, 300);
  ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, 300);
  ctx.strokeStyle = '#e9edf2'; ctx.lineWidth = 1;
  ctx.beginPath(); ctx.arc(w - 60, 62, 21, 0, Math.PI * 2); ctx.stroke();
  ctx.fillStyle = '#eff2f6';
  for (let i = 0; i < 3; i++) { const x = 120 + i * 250; ctx.fillRect(x, 77 + i * 17, 45, 3); ctx.fillRect(x + 11, 71 + i * 17, 20, 6); }
  ctx.fillStyle = '#9da9b6'; ctx.fillRect(0, GROUND + 1, w, 1);
  ctx.fillStyle = '#d2d9e2';
  const offset = (game.elapsed * game.speed) % 64;
  for (let x = -offset; x < w; x += 64) { ctx.fillRect(x, GROUND + 13, 12, 2); ctx.fillRect(x + 31, GROUND + 24, 4, 2); }
  drawDinosaur(ctx, PLAYER_X, GROUND - PLAYER_HEIGHT - game.height, game.status === 'running' && game.height === 0 ? 1 + Math.floor(game.elapsed * 10) % 2 : 0);
  ctx.fillStyle = '#222a35';
  for (const obstacle of game.obstacles) {
    const y = GROUND - obstacle.height;
    ctx.fillRect(obstacle.x + 9, y, 9, obstacle.height);
    ctx.fillRect(obstacle.x, y + 13, 6, 18);
    ctx.fillRect(obstacle.x + 4, y + 26, 10, 6);
    ctx.fillRect(obstacle.x + 18, y + 9, 6, 17);
    ctx.fillRect(obstacle.x + 13, y + 22, 9, 6);
    if (obstacle.width > 24) ctx.fillRect(obstacle.x + 28, y + 18, 8, obstacle.height - 18);
  }
}
